module.exports = __webpack_public_path__ + "img/Arrow_Line_Down.909079e0.svg";